<template>
  <img :width="width" :src="meetingIconUrl" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MeetingIcon",
  props: {
    meetingIcon: { type: String, required: false, default: "meeting" },
    width: { type: Number, required: false },
  },
  computed: {
    meetingIconUrl() {
      return new URL(
        `../../assets/apps/${this.meetingIcon}.svg`,
        import.meta.url
      ).href;
    },
  },
});
</script>
